// extracted by mini-css-extract-plugin
module.exports = {"links":"Links_links__9iqdN","links__item":"Links_links__item__01SPO","links__itemActive":"Links_links__itemActive__9nb_j"};